import QRCode from 'qrcode';

export async function generateQRCode(data: string): Promise<string> {
  try {
    const qrDataUrl = await QRCode.toDataURL(data, {
      width: 200,
      margin: 2,
      color: {
        dark: '#111111', // off-black
        light: '#ffffff',
      },
      errorCorrectionLevel: 'M',
    });
    return qrDataUrl;
  } catch (error) {
    console.error('QR code generation failed:', error);
    return '';
  }
}

export function getVenmoPaymentUrl(username: string, amount?: number, note?: string): string {
  const baseUrl = 'https://venmo.com/';
  const cleanUsername = username.replace('@', '');

  if (amount) {
    const params = new URLSearchParams({
      txn: 'pay',
      amount: amount.toString(),
      ...(note && { note }),
    });
    return `${baseUrl}${cleanUsername}?${params.toString()}`;
  }

  return `${baseUrl}${cleanUsername}`;
}

export function getCashAppPaymentUrl(cashtag: string, amount?: number): string {
  // Clean the cashtag
  const cleanTag = cashtag.replace('$', '');

  if (amount) {
    return `https://cash.app/$${cleanTag}/${amount}`;
  }

  return `https://cash.app/$${cleanTag}`;
}
